import { useEffect } from "react";
import {
  Nav,
  Hero,
  TrustStrip,
  LogoStripV2,
  DevelopmentOverview,
  HeroVideoV2,
  HowItWorksV2,
  ServicesGridV2,
  MarketingPinnedV2,
  MarketingCreativeV2,
  CaseStudiesV2,
  Testimonials,
  FAQ,
  FinalCTA,
  Blog,
  Footer,
  MediaMarqueeV5,
  UISnippetsGridV5,
  MediaBackgroundV5,
  HorizontalShowcaseV5,
  LifestyleSpotlightV5,
} from "../App";

/**
 * HomeV6 — clone of V5.
 * Identical structure to V5; provided as a separate canvas for
 * V6-specific iterations without affecting V5.
 */
export default function HomeV6() {
  useEffect(() => {
    document.title = "Sunday Digital — V6";
  }, []);

  return (
    <div
      data-testid="home-page"
      data-variant="v6"
      className="min-h-screen bg-[#0B0F14] text-neutral-100 font-body"
    >
      <Nav />
      <main>
        <Hero />
        <TrustStrip />
        <LogoStripV2 />
        <MediaMarqueeV5 />
        <DevelopmentOverview />
        <HeroVideoV2 />
        <HowItWorksV2 />
        <UISnippetsGridV5 />
        <ServicesGridV2 />
        <MediaBackgroundV5 />
        <MarketingPinnedV2 />
        <HorizontalShowcaseV5 />
        <MarketingCreativeV2 />
        <LifestyleSpotlightV5 />
        <CaseStudiesV2 />
        <Testimonials />
        <FAQ />
        <FinalCTA />
        <Blog />
      </main>
      <Footer />
    </div>
  );
}
